// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import { ShipData } from "../../../model/ship/ShipData";
import UserDataManage from "../../../model/UserDataManage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ShipSelectBuyLayer extends BasePopUpLayer {

	@property({ type: cc.Label, displayName:'' })
	labelTotalPrice: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelClick: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprIcon: cc.Sprite = null;


	@property({ type: cc.Label, displayName:'' })
	labelNum: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelTitle: cc.Label = null;

    @property({ type: cc.Label, displayName:'' })
	labelStore: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPrice: cc.Label = null;

    private selectNum = 1;

    private oriWidth = 0;
    private oriHeight = 0;
    private shipData: ShipData = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.oriHeight = this.sprIcon.node.height * this.sprIcon.node.scaleY;
        this.oriWidth = this.sprIcon.node.width * this.sprIcon.node.scaleX;
        O1HD.getModules().uiControlModule.hideLoading();
        this.initLayer();
    }

    initLayer() {
        let shipId = this._carryData.shipId;
        let bSell = this._carryData.bSell;

        this.shipData = UserDataManage.instance.shipDataManage.shipData.lists.get(shipId);

        this.labelPrice.string = "单价：" + data_control.getNumberFormat(this.shipData.price);
        if (bSell) {
            this.labelClick.string = '确认出售';
            this.labelTitle.string = '请选择售出数量';
            this.labelStore.string = '拥有：' + data_control.getNumberFormat(this.shipData.ownCount) + '条';
        } else {
            this.labelClick.string = '确认购买';
            this.labelTitle.string = '请选择购买数量';
            this.labelStore.string = '库存：' + data_control.getNumberFormat(this.shipData.store) + '条';
        }

        this.adjustNum();
        this.refreshIcon();
        this.refreshNum();
    }

    refreshIcon() {
        this.sprIcon.node.active = false;

        let path = 'assets/ship/items/' + this._carryData.icon;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.investStockGameBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprIcon.node.active = true;
                    this.sprIcon.spriteFrame = imgs;

                    let scaleX = this.oriWidth / this.sprIcon.node.width;
                    let scaleY = this.oriHeight / this.sprIcon.node.height;
                    this.sprIcon.node.scale = Math.min(scaleX, scaleY);
                }
            }
        );
    }

    refreshNum() {
        let bSell = this._carryData.bSell;
        let price = this.shipData.price;
        let allPrice = this.selectNum * price;
        this.labelNum.string = data_control.getNumberFormat(this.selectNum);
        if (bSell) {
            this.labelTotalPrice.string = '总售价：' + data_control.getNumberFormat(allPrice);
        } else {
            this.labelTotalPrice.string = '需花费：' + data_control.getNumberFormat(allPrice);
        }
    }

    adjustNum() {
        let bSell = this._carryData.bSell;
        let count = 0;
        if (bSell) {
            count = this.shipData.ownCount;
        } else {
            count = this.shipData.store;
        }
        this.selectNum = Math.max(1, Math.min(this.selectNum, count));
        this.refreshNum();
    }

    onClickAdd() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        this.selectNum++;
        this.adjustNum();
    }

    onClickSub() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.selectNum--;
        this.adjustNum();
    }

    onClickMin() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.selectNum = 1;
        this.adjustNum();
    }

    onClickMax() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        let bSell = this._carryData.bSell;
        let count = 0;
        if (bSell) {
            count = this.shipData.ownCount;
        } else {
            count = this.shipData.store;
        }
        this.selectNum = count;
        this.adjustNum();
    }

    onClickConfirm(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let bSell = this._carryData.bSell;

        let node = event.getCurrentTarget();

        let count = 0;
        if (bSell) {
            count = this.shipData.ownCount;
        } else {
            count = this.shipData.store;
        }
        this.selectNum = Math.max(1, Math.min(this.selectNum, count));
        let price = this.shipData.price;
        let allPrice = this.selectNum * price;
        if (bSell) {
            this.shipData.ownCount -= this.selectNum;
            this.shipData.ownCount = Math.max(0, this.shipData.ownCount);
            O1HD.getServices().userSrv.setCoins(allPrice, true, node);
        } else {
            let gold = O1HD.getServices().userSrv.getCoins();
            if (gold < allPrice) {
                O1HD.getModules().uiControlModule.showMessageBox('金额不足');
                return;
            }
            O1HD.getServices().userSrv.setCoins(-allPrice, true);
            this.shipData.ownCount += this.selectNum;
            this.shipData.store -= this.selectNum;
            this.shipData.store = Math.max(0, this.shipData.store);
        }
        UserDataManage.instance.shipDataManage.shipData.saveLocalData();

        this._carryData.parent.refreshUI();
        this.destroyNode();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
